import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { VariableSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

import axios from "../components/Axios";
import "./Logo.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errorMessage: "",
      email: "",
      password: "",
      remember: false,
      images: [],
      rowMaxHeight: 450,
    };
  }

  componentDidMount() {
    //remember
    axios
      .get(window.location.origin + "/json/gt.json")
      .then(
        function (response) {
          this.setState({ images: response.data }, function () {
            this.getDetections();
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  getDetections() {
    let exp = new URLSearchParams(this.props.location.search).get("exp");
    if (exp == null) exp = 81;

    axios
      .get(window.location.origin + "/json/exp" + exp + ".json")
      .then(
        function (response) {
          this.setState(
            function (state) {
              for (let i in response.data) {
                if (state.images[i].image_id == response.data[i].image_id)
                  state.images[i].detections = response.data[i].detections;
                else
                  console.log(
                    "diff image_id",
                    state.images[i],
                    response.data[i]
                  );
              }

              return state;
            },
            function () {
              this.setState({ loading: false });
            }
          );
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  getItemSize(index) {
    let h = parseInt(this.state.images[index].height);
    if (h > this.state.rowMaxHeight) h = this.state.rowMaxHeight;
    return h;
  }

  getRowStyle(index, style) {
    let h = parseInt(this.state.images[index].height);
    if (h > this.state.rowMaxHeight) {
      let s = this.state.rowMaxHeight / h;
      return { ...style, transform: `scale(${s}, ${s})` };
    } else return style;
  }

  getBBoxStyle(bbox) {
    return {
      left: parseInt(bbox[0]),
      top: parseInt(bbox[1]),
      width: bbox[2] - bbox[0],
      height: bbox[3] - bbox[1],
    };
  }

  render() {
    return (
      <div className="logoBackground">
        <AutoSizer>
          {({ height, width }) => (
            <List
              height={height}
              width={width}
              itemCount={this.state.images.length}
              itemSize={this.getItemSize.bind(this)}
              overscanCount={4}
            >
              {({ index, style }) => (
                <div className="logoRow" style={this.getRowStyle(index, style)}>
                  <div className="logoImgDiv">
                    <img
                      src={
                        "https://videoviews.autonomal.com/logo/" +
                        this.state.images[index].image_id
                      }
                    ></img>
                    <div className="rowNum">{index}.</div>
                    {this.state.images[index].bboxes.map((box, i) => (
                      <div
                        key={"img" + index + "_bbox" + i}
                        className="bbox_gt"
                        style={this.getBBoxStyle(box)}
                      />
                    ))}
                  </div>
                  {!this.state.loading && (
                    <div className="logoImgDiv">
                      <img
                        src={
                          "https://videoviews.autonomal.com/logo/" +
                          this.state.images[index].image_id
                        }
                      ></img>
                      {this.state.images[index].detections.map((d, i) => (
                        <div
                          key={"img" + index + "_bbox" + i}
                          className="bbox_pred"
                          title={"Confidence: " + d.score}
                          style={this.getBBoxStyle(d.bbox)}
                        >
                          {parseFloat(d.score).toFixed(3)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </List>
          )}
        </AutoSizer>
      </div>
    );
  }
}

export default withRouter(Index);
